import { createContext } from 'react';

const SiteEditContext = createContext<{
  siteEditPermission: boolean;
}>(undefined);

export default SiteEditContext;
